module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/document-0dc79a25c6f8f04495c44a19208ad569.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/document.svg
// module id = 618
// module chunks = 0